import gsap from 'gsap'
import {awdScroll, validateEmail} from './bundle'

class MyAccount {
    constructor() {
        this.filters = document.querySelector('.woocommerce-MyAccount-navigation')
        this.list = document.querySelector('.woocommerce-MyAccount-content')
        this.products = document.getElementById('products')
        this.products2Return = document.getElementById('products-to-return')
        this.privacy = document.querySelector('.return__form .return__form_item.pry label')
        this.orders = document.getElementById('return-order-id')
        this.returnSend = document.getElementById('return-send')

        this.init()
    }

    init() {
        if (this.privacy) {
            this.privacy.addEventListener('click', () => {
                let inp = this.privacy.querySelector('#return-privacy')
                if (inp.checked) {
                    this.privacy.classList.add('checked')
                } else {
                    this.privacy.classList.remove('checked')
                }
            })
        }
        if (this.orders) {
            this.orders.addEventListener('change', () => {
                if (this.orders.value != '') {
                    this.changeOrder(this.orders.value)
                } else {
                    this.products.classList.add('prds-no-margin')
                    this.products.classList.remove('prds')
                }
            })
        }
        if (this.returnSend) {
            this.returnSend.addEventListener('click', () => {
                this.sendReturn()
            })
        }
    }

    changeOrder(id) {
        if (this.products.classList.contains('prds-no-margin')) {
            this.products.classList.remove('prds-no-margin')
            this.products.classList.add('prds')
        }
        let formData = new FormData()
        let request = new XMLHttpRequest()
        formData.append('action', 'change-order-products')
        formData.append('order', id)
        let url = document.getElementById('uri').value + '/AJAX/returns.php'
        request.open('POST', url, true)
        request.onreadystatechange = () => {
            if (request.readyState === XMLHttpRequest.DONE && request.status === 200) {
                let res = JSON.parse(request.response)
                this.products.innerHTML = res.products
                this.selectProducts()
                awdScroll.update()
            }
        }
        request.send(formData)
    }

    selectProducts() {
        let elements = [...this.products.querySelectorAll('li')]
        elements.forEach((el) => {
            el.addEventListener('click', () => {
                el.classList.toggle('selected')
            })
        })
    }


    sendReturn() {
        let conts = document.querySelectorAll('.return__form_item');
        [...conts].forEach((el) => {
            el.classList.remove('err-1', 'err-2');
        });

        let name = document.getElementById('return-name');
        let surname = document.getElementById('return-surname');
        let mail = document.getElementById('return-mail');
        let tel = document.getElementById('return-telephone');
        let order = document.getElementById('return-order-id');
        let issue = document.getElementById('return-issue');
        let products = document.getElementById('products').querySelectorAll('li.selected');
        let message = document.getElementById('return-message');
        let privacy = document.getElementById('return-privacy');
        let prds = [];

        if (name.value.trim() != '' && surname.value.trim() != '' && mail.value.trim() != '' && validateEmail(mail.value.trim()) && order.value != '' && issue.value != '' && privacy.checked && products.length > 0) {
            [...products].forEach((prd, index) => {
                prds[index] = {
                    "id": prd.dataset.id,
                    "var": prd.dataset.var
                }
            });

            let formData = new FormData();
            let request = new XMLHttpRequest();
            formData.append('action', 'send-return');
            // formData.append('lang', getCookie('wp-wpml_current_language'));
            formData.append('name', name.value.trim());
            formData.append('surname', surname.value.trim());
            formData.append('mail', mail.value.trim());
            formData.append('tel', tel.value.trim());
            formData.append('order', order.value.trim());
            formData.append('issue', issue.value.trim());
            formData.append('products', JSON.stringify(prds));
            formData.append('message', message.value.trim());

            let ret_form = document.querySelector('.return__form');
            let ret_success = document.querySelector('.return__success');

            let url = document.getElementById('uri').value + '/AJAX/returns.php';
            request.open('POST', url, true);
            request.onreadystatechange = function () {
                if (request.readyState === XMLHttpRequest.DONE && request.status === 200) {
                    // console.log(request.response)
                    // let res = JSON.parse(request.response);
                    // if (res.return == 200) {
                    gsap.to(ret_form, { duration: 0.5, autoAlpha: 0 });
                    ret_success.style.display = 'block';
                    gsap.to(ret_success, { duration: 0.5, autoAlpha: 1, delay: 0.5 });
                    awdScroll.scrollTo(0, {
                        duration: 500,
                        easeing: [1, 0, 0, 1]
                    })
                    // }
                }
            };
            request.send(formData);

        } 
        else {
            if (name.value.trim() == '') {
                name.closest('.return__form_item').classList.add('err-1');
            }
            if (surname.value.trim() == '') {
                surname.closest('.return__form_item').classList.add('err-1');
            }
            if (mail.value.trim() == '' || !validateEmail(mail.value.trim())) {
                if (mail.value.trim() == '') {
                    mail.closest('.return__form_item').classList.add('err-1');
                } else {
                    mail.closest('.return__form_item').classList.add('err-2');
                }
            }
            if (order.value == '') {
                order.closest('.return__form_item').classList.add('err-1');
            }
            if (issue.value == '') {
                issue.closest('.return__form_item').classList.add('err-1');
            }
            if (!privacy.checked) {
                privacy.closest('label').closest('.return__form_item').classList.add('err-1');
            }
            if (products.length == 0 && order.value != '') {
                document.getElementById('products').classList.add('err-1');
            }
        }
    }

}


export {MyAccount}